<template>
  <UiNarrowContent>
      <div class="border-b border-black"> 
          <UiNewsItem 
              v-for="article in sortedArticles" 
              :article="article" 
              :key="article.id"
              :openedHandle="openedHandle"
              @update-handle="setOpenedHandle"
          />
      </div>
  </UiNarrowContent>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

// Props
const props = defineProps({
  articles: {
      type: Array,
      required: true
  },
  tag: {
      type: String,
      required: false,
      default: null
  }
});

const route = useRoute();
const router = useRouter();
const openedHandle = ref(route.params.article || null);

// Function to update the opened article handle
const setOpenedHandle = (handle) => {
    if (openedHandle.value === handle) {
        // Close if the same article is clicked
        openedHandle.value = null;
        window.history.replaceState(null, '', '/news'); // Change URL without navigating
    } else {
        // Open a new article
        openedHandle.value = handle;
        window.history.replaceState(null, '', `/news/${handle}`); // Change URL without navigating
    }
};

// Watch for direct URL changes and update state
watch(() => route.params.article, (newHandle) => {
    openedHandle.value = newHandle;
});

// Sort articles by 'publishedAt' field, latest first (newest to oldest)
const sortedArticles = computed(() => {
  return [...props.articles].sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt));
});
</script>

